// Idle/intent prefetch for lazy route chunks. Never part of the initial readiness gate.
import { getPublic } from "./dataCache";

const done = new Set();

const constrained = () => {
  const c = navigator.connection;
  return !!c && (c.saveData || /2g/.test(c.effectiveType || ""));
};

export function prefetchRoute(key, importer) {
  if (done.has(key) || constrained()) return;
  done.add(key);
  const run = () => importer().catch(() => done.delete(key));
  if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 3000 });
  else setTimeout(run, 300);
}

/* Intent prefetch: hover (desktop) or pointerdown/touchstart (mobile) starts the route chunk AND
   the public menu request in parallel. The click then reuses the exact in-flight request through
   dataCache's dedup, so opening a restaurant no longer waits chunk -> then -> data. */
export function prefetchRestaurant(slug) {
  if (!slug || constrained()) return;
  importRestaurantPage().catch(() => {});
  // getPublic itself is a no-op when the entry is still fresh, and re-fetches once it is stale
  // or was invalidated — so intent prefetch keeps working for the whole session.
  getPublic(`/restaurants/${slug}/menu`).catch(() => {});
}

export const importRestaurantPage = () => import("../pages/customer/RestaurantPage");
export const importOrderTracking = () => import("../pages/customer/OrderTracking");
